/**
 * Wraps an async operation in a try/catch block and returns a tuple with the error and the data.
 *
 * @param promise - The promise to wrap in a try/catch block.
 * @template T - The type of the data returned by the promise.
 * @template E - The type of the error returned by the promise.
 * @returns A tuple with the error and the data.
 */
export async function tryCatch<T, E = Error>(promise: T | Promise<T>) {
  try {
    const data = await promise
    return [null, data] as const
  } catch (error) {
    return [error as E, null] as const
  }
}
